"use client";

import Image from "next/image";

export default function ProjectTimeline() {

    return (
        <div className="/*bg-bluebirdlightblue*/">
            <h1 className="text-4xl p-4 pl-12 mt-4">Project Timeline</h1>
            
            <div className="relative w-full max-w-4xl mx-auto">
                {/* Wrapper for Image and Hotspots */}
                <div className="relative w-full aspect-[527/608] flex items-center justify-center">
                    <div className="relative w-[100%] h-[100%]">
                    
                        {/* Main figure */}
                        <Image
                            src="/projectoverview/projecttimeline.png"
                            alt="Business Modeling"
                            fill
                            className="object-cover"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}